import { AutosuggestProps } from '@amzn/awsui-components-react';
import { PapiLocation } from '@amzn/red-velvet-api';
import { getClient } from '../utils/getClient';

export async function loadLocationSuggestions(
  searchText: string,
  eventType: 'on-campus' | 'off-campus' | 'virtual',
  features: string[]
): Promise<AutosuggestProps.Option[]> {
  if (!searchText || searchText.trim().length === 0 || eventType === 'virtual') {
    return [];
  }

  try {
    const client = getClient(features);
    const response = await client.searchLocations({
      query: searchText,
      type: eventType === 'on-campus' ? 'on-campus' : undefined,
    });

    const locations = response.locations || [];

    // Process results based on event type
    let processedLocations = locations;

    if (eventType === 'off-campus') {
      // De-duplicate by city, state, country
      const uniqueLocations = new Map<string, PapiLocation>();
      locations.forEach((location: PapiLocation) => {
        const key = `${location.address.city}-${location.address.region}-${location.address.country}`;
        if (!uniqueLocations.has(key)) {
          uniqueLocations.set(key, location);
        }
      });
      processedLocations = Array.from(uniqueLocations.values());
    }

    // Convert to AutosuggestProps.Option format
    const locationOptions: AutosuggestProps.Option[] = processedLocations.map(
      (location: PapiLocation) => {
        const displayValue =
          eventType === 'on-campus'
            ? location.address.building
            : `${location.address.city}, ${location.address.region}, ${location.address.country}`;
        return {
          value: displayValue,
          label: displayValue,
          data: location, // Store the full location data for later use
        };
      }
    );

    return locationOptions;
  } catch (error) {
    console.error('Error loading location suggestions:', error);
    return [];
  }
}
